import React from 'react';
import T from 'prop-types';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { VIEWS } from 'workflow/constants/newInbox';

import { colorBlue1 } from 'styles/_colors.scss';

import styles from './BackToInbox.scss';

export const BackToInbox = ({ changeView }) => {
    return (
        <div className={styles.BackToInbox} onClick={() => changeView(VIEWS.TASK_LIST)} data-cy="BackToInbox">
            <ArrowBackIcon style={{ color: colorBlue1 }} />
            <span className={styles.BackToInbox__Text}>Back to Inbox</span>
        </div>
    );
};

export const BackToMyTasksV4 = ({ changeView }) => {
    return (
        <div className={styles.BackToInbox} onClick={() => changeView()} data-cy="BackToMyTasksV4">
            <ArrowBackIcon style={{ color: colorBlue1 }} />
            <span className={styles.BackToInbox__Text}>Back to My Tasks</span>
        </div>
    );
};

BackToInbox.propTypes = {
    changeView: T.func.isRequired
};